import React, { useState } from "react";
import { createPortal } from "react-dom";
import { CloseFullscreen, OpenWith, Add, Remove } from "@mui/icons-material";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

export default function InteractivePane({ children }) {
  const [isMovable, setIsMovable] = useState();
  const [isExpanded, setIsExpanded] = useState(false);

  const onDrag = () => {
    setIsMovable(true);
  };

  const onStop = () => {
    setIsMovable(false);
  };

  const Pane = () => {
    return (
      <div className="interactive-pane-container">
        <div className="interactive-pane-patterns">
          <TransformWrapper
            initialScale={1}
            disabled={isMovable}
            minScale={0.3}
            maxScale={10}
            limitToBounds={false}
            pinch={{ step: 5 }}
          >
            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
              <>
                <div className="pane-controls">
                  <button
                    className="control-button"
                    onClick={() => setIsExpanded((isExpanded) => !isExpanded)}
                  >
                    {isExpanded ? (
                      <>
                        <CloseFullscreen style={{ color: "var(--text)" }} />
                        <p>Collapse</p>
                      </>
                    ) : (
                      <>
                        <OpenWith style={{ color: "var(--text)" }} />
                        <p>Expand</p>
                      </>
                    )}
                  </button>
                  <button className="control-button between" onClick={() => zoomIn(0.3)}>
                    <Add style={{ color: "var(--text)" }} />
                    <p>Zoom In</p>
                  </button>
                  <button className="control-button" onClick={() => zoomOut(0.3)}>
                    <Remove style={{ color: "var(--text)" }} />
                    <p>Zoom Out</p>
                  </button>
                </div>
                <TransformComponent>{children}</TransformComponent>
              </>
            )}
          </TransformWrapper>
        </div>
      </div>
    );
  };

  if (!isExpanded) return <Pane />;

  return createPortal(
    <div className="expanded-background">
      <div className="expanded-container">
        <Pane />
      </div>
    </div>,
    document.getElementById("expanded-pane"),
  );
}
